export default {
    AND: "AND",
    OR: "OR",
};
